import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Spin, Tag, Button, message } from 'antd'
import { formatDateTimeStr, formatDayString, parseHmStringToDayMinutes, renderTextStr } from '@/utils/renderUtils'
import { fetchTuinaReservation } from '@/redux/tuina/reservationDetailSlice'
import { TUINA_RESERVATION_STATUS_OPTIONS } from '@/views/tuina/options'
import Permission from '@/components/PermissionA5'
import ReservationRescheduleModal from './ReservationRescheduleModal'
import ReservationCancelModal from './ReservationCancelModal'
import './ReservationDetail.less'

function formatReservationClock (raw) {
  if (!raw) return ''
  const minutes = parseHmStringToDayMinutes(raw)
  if (minutes == null) return ''
  const hh = Math.floor(minutes / 60)
  const mm = minutes % 60
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}

class ReservationDetail extends React.Component {
  static propTypes = {
    record: PropTypes.object,
    reservationDetail: PropTypes.object,
    getJStoreList: PropTypes.object,
    onDispatch: PropTypes.func,
    onSuccess: PropTypes.func,
    onCancelSuccess: PropTypes.func,
    onClose: PropTypes.func,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { record, dispatch } = this.props
    if (record == null || record.id == null || record.id === '') return
    dispatch(fetchTuinaReservation({ query: { id: record.id } }))
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载预约详情失败'))
  }

  handleClose = () => {
    const { onClose } = this.props
    if (typeof onClose === 'function') onClose()
  }

  storeName = (storeId) => {
    const options = this.props.getJStoreList.data
    if (!Array.isArray(options)) return storeId
    const row = options.find((item) => String(item.id) === String(storeId))
    return row ? row.value : storeId
  }

  handleDispatch = (view) => {
    const { onDispatch } = this.props
    if (typeof onDispatch === 'function') onDispatch(view)
  }

  handleRescheduleSuccess = () => {
    const { record, dispatch, onSuccess } = this.props
    if (record && record.id != null && record.id !== '') {
      dispatch(fetchTuinaReservation({ query: { id: record.id } }))
        .unwrap()
        .catch((err) => message.error(typeof err === 'string' ? err : '加载预约详情失败'))
    }
    if (typeof onSuccess === 'function') onSuccess()
  }

  renderCancelButton = (view) => (
    <ReservationCancelModal
      record={view}
      zIndex={1100}
      onSuccess={this.props.onCancelSuccess}
    >
      <Button size="large" danger>取消预约</Button>
    </ReservationCancelModal>
  )

  renderStatus = (v) => {
    const row = TUINA_RESERVATION_STATUS_OPTIONS.find((item) => item.id === v)
    const text = (row && row.value) || v
    if (!text) return renderTextStr(text)
    return <Tag color={(row && row.color) || 'default'}>{text}</Tag>
  }

  render () {
    const { record, reservationDetail } = this.props
    const { fetching, data } = reservationDetail
    const row = record || {}
    const view = data && data.id != null && String(data.id) === String(row.id) ? data : row
    const start = formatReservationClock(view.startTime)
    const end = formatReservationClock(view.endTime)
    const timeText = start && end ? `${start} 至 ${end}` : (start || end)
    const duration = Number(view.durationMinutes)
    const durationText = view.durationMinutes == null || view.durationMinutes === '' || !Number.isFinite(duration)
      ? ''
      : `${duration}分钟`

    return (
      <Spin spinning={fetching}>
        <div className="tuina-rsv-detail">
          <div className="tuina-rsv-detail-head">
            <h2 className="tuina-rsv-detail-name">{renderTextStr(view.projectName)}</h2>
            {this.renderStatus(view.status)}
          </div>
          <p className="tuina-rsv-detail-meta">{renderTextStr(view.reservationNo)}</p>
          <dl className="tuina-rsv-detail-fields">
            <div>
              <dt>客户</dt>
              <dd>{renderTextStr(view.memberName || view.customer)}</dd>
            </div>
            <div>
              <dt>门店</dt>
              <dd>{renderTextStr(this.storeName(view.storeId))}</dd>
            </div>
            <div>
              <dt>师傅</dt>
              <dd>{view.therapistName ? renderTextStr(view.therapistName) : '待派'}</dd>
            </div>
            <div>
              <dt>日期</dt>
              <dd>{renderTextStr(formatDayString(view.appointmentDate))}</dd>
            </div>
            <div>
              <dt>时间</dt>
              <dd>{renderTextStr(timeText)}</dd>
            </div>
            <div>
              <dt>时长</dt>
              <dd>{renderTextStr(durationText)}</dd>
            </div>
            <div>
              <dt>备注</dt>
              <dd>{renderTextStr(view.remark)}</dd>
            </div>
            <div>
              <dt>取消原因</dt>
              <dd>{renderTextStr(view.cancelReason)}</dd>
            </div>
            <div>
              <dt>完成时间</dt>
              <dd>{renderTextStr(formatDateTimeStr(view.completedAt))}</dd>
            </div>
            <div>
              <dt>创建时间</dt>
              <dd>{renderTextStr(formatDateTimeStr(view.createdAt))}</dd>
            </div>
          </dl>
          <div className="tuina-rsv-detail-actions">
            <Permission rootPath="tuinaPage">
              <div pathitem={['board']} checkarray={['buttonCodes']} className="tuina-rsv-detail-actions-left">
                {!view.therapistId && view.status === 'booked' ? (
                  <>
                    {this.renderCancelButton(view)}
                    <Button size="large" type="primary" onClick={() => this.handleDispatch(view)}>
                      派单
                    </Button>
                  </>
                ) : view.status === 'booked' ? (
                  <>
                    {this.renderCancelButton(view)}
                    <ReservationRescheduleModal
                      record={view}
                      zIndex={1100}
                      onSuccess={this.handleRescheduleSuccess}
                    >
                      <Button size="large">改约</Button>
                    </ReservationRescheduleModal>
                  </>
                ) : null}
              </div>
            </Permission>
            <Button size="large" className="tuina-rsv-detail-actions-close" onClick={this.handleClose}>关闭窗口</Button>
          </div>
        </div>
      </Spin>
    )
  }
}

const mapStateToProps = (state) => ({
  reservationDetail: state.tuina.reservationDetail,
  getJStoreList: state.components.getJStoreList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ReservationDetail)
